import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../rootState'

export const getCurrentAdmin = createSelector(
  (state: RootState) => state.admin,
  admin =>
    [
      'SD',
      'ADMIN',
      'ACCOUNT_MANAGER',
      'ADMIN_ACCOUNTANT',
      'PERFORMANCE',
    ].includes(admin?.role)
      ? admin
      : null,
)
